var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12c0 5.018-5.488 8.403-7.075 9.276a.87.87 0 0 1-.85 0C9.988 20.403 4.5 17.018 4.5 12c0-4.5 3.634-7.5 7.5-7.5 4 0 7.5 3 7.5 7.5Z",
    stroke: "#B0B6BD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.5,
    stroke: "#B0B6BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationHhmtIcon);
export default __webpack_public_path__ + "static/media/location-hhmt-icon.40e00a5172d8c1fb7d122f6ab5f86460.svg";
export { ForwardRef as ReactComponent };